import type { ApisState } from '../../api/monitor';
import { OVERALL_TONE, formatCheckedAt, overallLabel } from '../../lib/health';

interface HealthBannerProps {
  state: ApisState;
  checking: boolean;
  onCheckNow: () => void;
}

/**
 * Faixa com a saúde geral e o botão "Verificar agora". Aparece igual no topo
 * da Administração e da tela de Status.
 */
export function HealthBanner({ state, checking, onCheckNow }: HealthBannerProps) {
  const tone = OVERALL_TONE[state.summary.status];

  return (
    <div className={`mb-3.5 flex items-center gap-2.5 rounded-xl border p-4 ${tone.banner}`}>
      <span className={`size-2.5 shrink-0 rounded-full ${tone.dot}`} />
      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-extrabold">{overallLabel(state.summary)}</div>
        <div className="mt-0.5 text-[11.5px] opacity-80">
          Verificação automática a cada {state.intervalMinutes}{' '}
          {state.intervalMinutes === 1 ? 'minuto' : 'minutos'} · última{' '}
          {formatCheckedAt(state.summary.checkedAt)}
        </div>
      </div>
      <button
        type="button"
        onClick={onCheckNow}
        disabled={checking}
        className="shrink-0 rounded-[9px] border border-black/10 bg-white/60 px-3.5 py-2 text-[12px] font-extrabold text-inherit disabled:opacity-60"
      >
        {checking ? 'Verificando…' : 'Verificar agora'}
      </button>
    </div>
  );
}
